import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from 'react-cookie-manager';

export const useGoogleTracking = () => {
  const trackingId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const location = useLocation();
  const { detailedConsent } = useCookieConsent();

  useEffect(() => {
    const analyticsConsented = detailedConsent?.Analytics?.consented === true;
    if (!analyticsConsented || !trackingId) return;

    // Dynamically inject the GA script only after consent
    const scriptId = 'google-analytics-script';
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      script.async = true;
      document.head.appendChild(script);
    }

    window.gtag('config', trackingId, {
      page_path: location.pathname,
    });
  }, [trackingId, location, detailedConsent]);
};
